import { takeEvery, put, select } from 'redux-saga/effects';
import pick from 'lodash/pick';
import companiesListActions from '../actionTypes/companiesActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_COMPANIES, DELETE_COMPANY } from '../routes';


const getFilters = (state) => pick(state.companiesReducer, ['per', 'page', 'query']);

function* getCompaniesList() {
  const filters = yield select(getFilters);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_COMPANIES,
      method: 'POST',
      data: { per: 10, page: 1, ...filters },
    },
    successAction: companiesListActions.getCompaniesListSuccess,
    failureAction: companiesListActions.getCompaniesListFailed,
  });
}

function* deleteCompany({ payload }) {
  const { id } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: DELETE_COMPANY.replace(':id', id),
      method: 'DELETE',
      data: payload,
    },
    successAction: companiesListActions.deleteCompanySuccess,
    failureAction: companiesListActions.deleteCompanyFailed,
  });
}

export default function* watchCompaniesList() {
  yield takeEvery(companiesListActions.getCompaniesList, getCompaniesList);
  yield takeEvery(companiesListActions.addNewCompanySuccess, getCompaniesList);
  yield takeEvery(
    companiesListActions.updateCompanyDetailsSuccess,
    getCompaniesList,
  );

  yield takeEvery(
    companiesListActions.deleteCompany,
    deleteCompany,
  );
  yield takeEvery(
    companiesListActions.deleteCompanySuccess,
    getCompaniesList,
  );
}
